import { DragDropContext, Draggable, DropResult, Droppable } from "@hello-pangea/dnd";
import { MemberInterface } from "@swivl-mono/types";
import { FC, useEffect, useState } from "react";
import "./MembersList.scss";

import { MembersListItem } from "./MembersListItem";

interface Props {
  onReorder: (members: MemberInterface[]) => void;
  onDelete: (memberId: number) => void;
  members: MemberInterface[];
}

const reorder = (list: MemberInterface[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const MembersList: FC<Props> = ({ members: membersProp, onReorder, onDelete }) => {
  const [members, setMembers] = useState<MemberInterface[]>([]);

  useEffect(() => {
    setMembers(membersProp);
  }, [membersProp]);

  const onDragEndHandler = (result: DropResult) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(members, result.source.index, result.destination.index);
    setMembers(items);
    onReorder(items);
  };

  const onDeleteHandler = (memberId: number) => {
    onDelete(memberId);
  };

  return (
    <DragDropContext onDragEnd={onDragEndHandler}>
      <Droppable droppableId="membersList">
        {(provided) => (
          <div className="MembersList" ref={provided.innerRef} {...provided.droppableProps}>
            {members.map((member, index) => (
              <Draggable key={member.id} draggableId={`${member.id}`} index={index}>
                {(provided) => (
                  <div
                    className="listItem"
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={provided.draggableProps.style}
                  >
                    <MembersListItem value={member} onDelete={onDeleteHandler} />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
